<h2 mat-dialog-title>Edit Localization for Hubbub Field Name: {{formField.formFieldLabel}}</h2>

<mat-dialog-content [formGroup]="form">
  
    <mat-form-field>
        <input matInput
                placeholder="Form Field Value"
               formControlName="formFieldLabel">
    </mat-form-field>
 
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-raised-button appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button class="submit-button" appPreventDoubleClick (throttledClick)="save()">Save</button>
</mat-dialog-actions>